import { activeTheme, themes } from '@/hooks/useTheme'
import { create } from 'zustand'

export type Locale = 'en' | 'th'

const defaultLocale: Locale = themes[activeTheme].locale

interface LocaleState {
  locale: Locale
}

export const useLocaleStore = create<LocaleState>()(() => ({
  locale: defaultLocale,
}))

export const getLocale = () => useLocaleStore.getState().locale
